<div class="global-container">
    <div class="left-container"> 
        <mat-card appearance="outlined" class="header-container">
            <div class="header-left-container">
                <h1 class="header-content">Agora Discussion ({{currentDate}})</h1>
            </div>
            <div class="header-right-container">
                <app-timer></app-timer>
            </div>
        </mat-card>
        <ng-scrollbar *ngIf = "deviceLg || deviceXl || deviceSm" track = "all" class="header-fixed-content-container" #scrollable pointerEventsMethod="scrollbar" [disabled]="false">
            <!-- <div class="header-fixed-content-container"> -->
                <div class="description-header-container">
                    <div class="desc-left-container">
                        <mat-icon class="calendar-icon">date_range</mat-icon>
                    </div>
                    <div class="desc-right-container">
                        <h2 class="description-content-container">Agora Discussion</h2>
                    </div>
                </div>
                <div>
                    <cdk-accordion class="example-accordion"> 
                        
                        <app-instant-meeting-description [useBool] = "boolean"></app-instant-meeting-description>
                        <mat-divider class="schedule-instant-divider"></mat-divider>
                        <app-instant-participants></app-instant-participants>
                        <mat-divider class="schedule-instant-divider"></mat-divider>
                        <app-instant-meeting-agenda></app-instant-meeting-agenda>
                    </cdk-accordion> 
                </div>
            <!-- </div> -->
        </ng-scrollbar>
        <div *ngIf = "deviceMd || deviceXs || deviceSm">
            <div class="description-header-container">
                    <div class="desc-left-container">
                        <mat-icon class="calendar-icon">date_range</mat-icon>
                    </div>
                    <div class="desc-right-container">
                        <h2 class="description-content-container">Agora Discussion</h2>
                    </div>
                </div>
                <div>
                    <cdk-accordion class="example-accordion"> 
                        
                        <app-instant-meeting-description [useBool] = "boolean"></app-instant-meeting-description>
                        <mat-divider class="schedule-instant-divider"></mat-divider>
                        <app-instant-participants></app-instant-participants>
                        <mat-divider class="schedule-instant-divider"></mat-divider>
                        <app-instant-meeting-agenda></app-instant-meeting-agenda>
                    </cdk-accordion> 
                </div>
        </div>    
    </div>
    <div class="right-container">
            <div>
                <button (click) = "previosMeetingDialog()" class="previous-meetings" mat-raised-button>Previous Meetings</button>
            </div>
            <div class="example-box" cdkDrag>
                video
            </div>
    </div>
</div>